/**
 * Maps a contextual-widget urgency state → the trace colour, identical to the
 * palette in components/actionCards/ActionCards.jsx. This keeps the TableShell
 * border trace the SAME colour as the active contextual-widget card, so the
 * trace visibly belongs to whichever filtering widget (Due Now / In Progress /
 * …) is currently applied to the table.
 *
 * Usage (inside a contextual widget, reporting its active card up to the page):
 *   onActiveWidgetChange({ label: card.label, color: urgencyColor(card.urgencyState) })
 */

// ISS-037 — this used to be a SECOND hard-coded copy of the ActionCards palette, with
// neutral: '#e2e8f0'. That is the same grey as an unselected card border, so whenever the
// active card's count was 0 (getUrgency* returns NEUTRAL for any zero count) the trace was
// drawn in near-white on a white board and the user got an empty table with nothing on
// screen explaining that a filter was applied — the ISS-036 defect on a second surface.
//
// Now derived from the single source of truth. resolveSelectionColor gives NEUTRAL its own
// visible slate, so a zero-count active card still traces.
import { resolveSelectionColor } from '../actionCards/actionCardColors';

export function urgencyColor(urgencyState) {
    return resolveSelectionColor(urgencyState);
}
